import { render, staticRenderFns } from "./main-login-form-popup.html?vue&type=template&id=30af9e88&scoped=true&external"
import script from "./main-login-form-popup.js?vue&type=script&lang=js&external"
export * from "./main-login-form-popup.js?vue&type=script&lang=js&external"
import style0 from "./main-login-form-popup.scss?vue&type=style&index=0&id=30af9e88&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30af9e88",
  null
  
)

export default component.exports